// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'

import '@/assets/css/reset.css'
import '@/assets/css/common.less'
import common from "./assets/js/common"

Vue.prototype.$common = common;

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})


let load
// 设置请求拦截器
axios.interceptors.request.use(config => {
  if (localStorage.getItem('loginToken')) {
    config.headers.Authorization = 'Bearer ' + localStorage.getItem('loginToken')
  }
  if(config.showLoading){
    load = ElementUI.Loading.service({
      lock: true,
      background: "rgba(0, 0, 0, 0.2)"
    });
  }
  return config
}, error => {
  return Promise.reject(error);
});

// 设置响应拦截器
axios.interceptors.response.use(res => {
  load.close()
  return res
}, error => {
  // 如果是正常接口，会走err，err.response.status值为401 进行跳转及删除token的操作
  if (error.response) {
    switch (error.response.status) {
      case 401:
        // 返回 401 清除token信息并跳转到登录页面
        localStorage.removeItem('loginToken')
        localStorage.removeItem('userInfo')
        location.href = '#/'
        location.reload()
        return Promise.reject("登录已过期,请重新登录");
      case 403:
        return Promise.reject("你没权限查询该资源");
      case 404:
        return Promise.reject("你所访问的资源不存在");
      case 500:
        return Promise.reject("服务器出错啦");
    }
  }
  return Promise.reject(error)
})

export default axios



// WEBPACK FOOTER //
// ./src/main.js